import Animation from './Animations'
import ScrollMagic from 'ScrollMagic';
import slick from 'slick-carousel'
import 'animation.gsap';
import 'debug.addIndicators';
import Odometer from 'odometer';
import imagesLoaded from 'imagesloaded';


window.onbeforeunload = function(){ window.scrollTo(0,0); }

var body = document.body; // Safari
var html = document.documentElement; // Chrome, Firefox, IE and Opera places the overflow at the <html> level, unless else is specified. Therefore, we use the documentElement property for these browsers
let animation = new Animation();
let controller = new ScrollMagic.Controller();
let header = document.querySelector('header');
let sections = document.querySelectorAll("section");
let ourLib = document.getElementById("our-library");
let footer = document.querySelector("footer");
let isDesktop = false;

if (window.innerWidth >= 960){
    isDesktop = true;
}




// main slider
$(document).ready(function(){
  $('.carousel').slick({
      prevArrow: '<button type="button" title="Previous Slide" aria-label="Previous Slide" class="slick-prev"></button>',
      nextArrow: '<button type="button" title="Next Slide"  aria-label="Next Slide" class="slick-next"></button>',
      dots: true,
      fade: true,
      autoplaySpeed:500,
      speed: 1000
  });

  imagesLoaded( header, { background: '.background-img' } ).on( 'done', () => {
            let headerTween = animation.headerIntro(header);
            // Timeout is used to start the slider after the animation
            setTimeout(()=>{
                $('.carousel').slick('slickPlay');
            },headerTween.duration()*800);
  });
});



// Animations parallax images
let parallaxScenes = [];
Array.prototype.forEach.call(sections, function(el, i){
    let images = el.querySelectorAll(".parallax-img__foreground");
    Array.prototype.forEach.call(images, function(childEl, j){
      let parallax = new ScrollMagic.Scene({triggerElement: el,offset:-250, duration: "70%" })
          // .addIndicators()
          .setTween(animation.slideIn(childEl));

          if (isDesktop) {
              parallax.addTo(controller);
          }
         parallaxScenes.push(parallax);

    });

    let text = el.querySelectorAll(".viewable");

    Array.prototype.forEach.call(text, function(txt, j){
      let fadingTxt = new ScrollMagic.Scene({triggerElement: el })
          // .addIndicators()
          .setClassToggle(txt, 'visible');
              fadingTxt.addTo(controller);

    });

});

// Numbers odometers
if (ourLib !== null) {
    let numbers = ourLib.querySelectorAll('.number__digit');
    let odometers = [];
    Array.prototype.forEach.call(numbers, function(el, i){
        let value = el.dataset.digit;
        odometers[i] = {
            od: new Odometer({el: el,value:0,format:'d'}),
            value: value
        }


    });
    let numberScroll = new ScrollMagic.Scene({triggerElement: ourLib, offset:"-200px"})
              // .addIndicators()
              .on('start', function () {
                    odometers.forEach(item => {
                        item.od.value=0;
                        item.od.update(item.value)
                    })
                })
              .addTo(controller)
}

// Artist Carousel
// slider
$(document).ready(function(){
  var mySlick = $('.artistSlider').slick({
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      vertical: true
  });

});


// footer animation
let footerAnimation = new ScrollMagic.Scene({triggerElement: footer, triggerHook:"onEnter", offset: "210px", duration:"500px",})
    // .addIndicators()
    .setTween(animation.slideIn(footer.querySelector('.footer__box')))

    if (isDesktop) {
        footerAnimation.addTo(controller);
    }
   parallaxScenes.push(footerAnimation);




function manageParallax() {
    if (isDesktop && window.innerWidth < 960) {
        isDesktop = false;
        parallaxScenes.forEach(scene => {
            scene.progress(1);
            scene.remove();
        })
    }else if (!isDesktop && window.innerWidth >= 960) {
        isDesktop = true;
        parallaxScenes.forEach(scene => {
            scene.addTo(controller);
        })
    }
}

window.addEventListener('resize', manageParallax);

let scrollBtn = document.getElementById('scroll-down');
let quote = document.querySelector('.quote');


window.addEventListener('scroll', (e) =>{
    if (html.scrollTop > 50 || body.scrollTop > 50){
        if(!scrollBtn.classList.contains('hidden')){
         scrollBtn.classList.add('hidden')
        }
        if(!quote.classList.contains('visible')){
         quote.classList.add('visible')
        }
    }else{
        if (scrollBtn.classList.contains('hidden')){
         scrollBtn.classList.remove('hidden')
        }
        if (quote.classList.contains('visible')){
         quote.classList.remove('visible')
        }
    }
})
if (scrollBtn !== null) {
    scrollBtn.addEventListener('click', e => {
        e.preventDefault();
        let href = scrollBtn.getAttribute('href');
        let split = href.split('#')
        let elem = document.getElementById(split[split.length - 1])

        elem.scrollIntoView(
            {
                behavior: "smooth",
                block: "start"
            });

    });
}



// WEBPACK FOOTER //
// ./themes/art-library/javascript/main.js